import PropTypes from 'prop-types';

export const identifierType = PropTypes.shape({
  _id: PropTypes.string,
  id: PropTypes.string,
});

export const valueType = PropTypes.shape({
  value: PropTypes.number,
  label: PropTypes.string,
});
